import { http } from '../../config/axios'

export default function patchClientStatus(idCliente: string, inativo: boolean): Promise<string> {
  return http
    .patch('api/client/'+idCliente, {inativo: inativo})
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro patch cliente status', error)
      throw Error(error.response.data)
    })
}